import script from "./CustomAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomAlert.vue?vue&type=script&setup=true&lang=ts"

import "./CustomAlert.vue?vue&type=style&index=0&id=dc74a14a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc74a14a"]])

export default __exports__